











import { computed, defineComponent } from '@nuxtjs/composition-api';
import useMyStore from '@shared/composables/useMyStore';
import useUiState from '@shared/composables/useUiState';
import { UCAppHeaderItem } from '@shared/ui';

export default defineComponent({
  name: 'HeaderStore',
  components: { UCAppHeaderItem },
  setup() {
    const { toggleStoresSidebar } = useUiState();
    const { myStore } = useMyStore();

    const selectedStoreName = computed(() => myStore?.value?.shortName);

    return {
      selectedStoreName,
      toggleStoresSidebar,
    };
  },
});
